// extracted by css-extract-rspack-plugin
export default {"title":"PreviewPdfModal__title--Taq4T","header":"PreviewPdfModal__header--BkzyH","tools":"PreviewPdfModal__tools--Cyzw8"};